export interface VideoItem {
  id: string;
  title: string;
  slug: string;
  thumbnail: string;
  duration: string;
  category: string;
  categorySlug: string;
  views: string;
  rating: string;
  description: string;
  publishDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const featuredVideos: VideoItem[] = [
  {
    id: "v001",
    title: "流浪地球3：星际远征",
    slug: "liulang-diqiu-3",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spaceship%20approaching%20a%20massive%20ring-shaped%20space%20station%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20deep%20space%20background%20with%20stars%2C%20warm%20orange%20and%20gold%20accents%2C%20high%20contrast%2C%20movie%20poster%20style&width=640&height=360&seq=video-thumb-001&orientation=landscape",
    duration: "02:28:15",
    category: "电影",
    categorySlug: "dianying",
    views: "1280万",
    rating: "9.2",
    description: "人类面临前所未有的星际危机，一支由精英宇航员组成的远征队踏上未知旅程，探索新的宜居星球。",
    publishDate: "2026-07-28",
    tags: ["科幻", "冒险", "国产大片"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v002",
    title: "长安风云录",
    slug: "changan-fengyunlu",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20traditional%20architecture%2C%20ornate%20costumes%2C%20warm%20candlelight%2C%20historical%20Tang%20dynasty%20setting%2C%20cinematic%20lighting%2C%20rich%20red%20and%20gold%20color%20palette&width=640&height=360&seq=video-thumb-002&orientation=landscape",
    duration: "45:30",
    category: "电视剧",
    categorySlug: "dianshiju",
    views: "980万",
    rating: "8.9",
    description: "以唐朝长安城为背景，讲述一段跨越三代的权谋与爱情故事，宫廷内外风起云涌。",
    publishDate: "2026-07-25",
    tags: ["古装", "权谋", "爱情"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v003",
    title: "极限挑战：荒野求生季",
    slug: "jixian-tiaozhan",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20reality%20show%20scene%2C%20group%20of%20people%20in%20dense%20forest%2C%20warm%20sunlight%20through%20trees%2C%20excitement%20and%20teamwork%2C%20cinematic%20photography%2C%20earthy%20green%20and%20gold%20tones&width=640&height=360&seq=video-thumb-003&orientation=landscape",
    duration: "01:35:20",
    category: "综艺",
    categorySlug: "zongyi",
    views: "1560万",
    rating: "9.5",
    description: "六位明星嘉宾被空降到无人荒野，在极限环境中展开为期七天的生存挑战，笑料与感动并存。",
    publishDate: "2026-07-30",
    tags: ["真人秀", "户外", "明星"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v004",
    title: "星际猎人：暗影纪元",
    slug: "xingji-lieren",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20style%20sci-fi%20scene%20with%20futuristic%20bounty%20hunter%20in%20neon-lit%20cyberpunk%20city%2C%20dramatic%20action%20pose%2C%20vibrant%20warm%20neon%20orange%20and%20pink%20accents%2C%20anime%20art%20style%2C%20high%20detail&width=640&height=360&seq=video-thumb-004&orientation=landscape",
    duration: "24:00",
    category: "动漫",
    categorySlug: "dongman",
    views: "820万",
    rating: "9.1",
    description: "在未来星际时代，一名赏金猎人在各大星球间追捕逃犯，揭开隐藏在暗影中的惊天阴谋。",
    publishDate: "2026-07-22",
    tags: ["科幻", "动作", "日漫"],
    isHot: true,
    isNew: false,
  },
  {
    id: "v005",
    title: "蓝色星球：深海秘境",
    slug: "lanse-xingqiu",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20underwater%20documentary%20scene%20with%20colorful%20coral%20reef%20and%20diverse%20marine%20life%2C%20crystal%20clear%20deep%20blue%20water%2C%20sunlight%20rays%20penetrating%20ocean%20surface%2C%20cinematic%20nature%20photography&width=640&height=360&seq=video-thumb-005&orientation=landscape",
    duration: "52:10",
    category: "纪录片",
    categorySlug: "jilupian",
    views: "650万",
    rating: "9.7",
    description: "跟随顶级海洋生物学家潜入深海，探索人类从未涉足的神秘海底世界与奇特生物。",
    publishDate: "2026-07-15",
    tags: ["自然", "海洋", "探索"],
    isHot: false,
    isNew: true,
  },
  {
    id: "v006",
    title: "2026世界杯决赛：中国VS巴西",
    slug: "2026-worldcup",
    thumbnail: "https://readdy.ai/api/search-image?query=Exciting%20soccer%20match%20scene%20with%20players%20celebrating%20goal%20on%20stadium%20field%2C%20dramatic%20stadium%20lights%2C%20passionate%20crowd%20in%20background%2C%20sports%20photography%2C%20warm%20golden%20hour%20lighting&width=640&height=360&seq=video-thumb-006&orientation=landscape",
    duration: "03:15:00",
    category: "体育",
    categorySlug: "tiyu",
    views: "3200万",
    rating: "9.6",
    description: "历史性时刻！中国队首次闯入世界杯决赛，与五星巴西争夺世界之巅的荣耀。",
    publishDate: "2026-07-20",
    tags: ["足球", "世界杯", "中国"],
    isHot: true,
    isNew: false,
  },
];

export const latestVideos: VideoItem[] = [
  {
    id: "v007",
    title: "密室大逃亡第五季",
    slug: "mishi-taowang-5",
    thumbnail: "https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20setting%20with%20dim%20warm%20lighting%2C%20puzzle%20elements%2C%20team%20of%20people%20solving%20clues%2C%20suspenseful%20atmosphere%2C%20reality%20show%20style%20photography&width=640&height=360&seq=video-thumb-007&orientation=landscape",
    duration: "01:20:15",
    category: "综艺",
    categorySlug: "zongyi",
    views: "890万",
    rating: "8.7",
    description: "全新一季密室挑战升级，明星嘉宾需要在限定时间内破解重重机关，逃出神秘密室。",
    publishDate: "2026-08-01",
    tags: ["密室", "推理", "明星"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v008",
    title: "武林外传：新篇章",
    slug: "wulin-waizhuan-xin",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20comedy%20drama%20scene%20in%20traditional%20inn%20setting%2C%20colorful%20costumes%2C%20warm%20lighting%2C%20humorous%20expression%2C%20period%20drama%20style%20with%20modern%20comedic%20elements&width=640&height=360&seq=video-thumb-008&orientation=landscape",
    duration: "42:30",
    category: "电视剧",
    categorySlug: "dianshiju",
    views: "750万",
    rating: "8.5",
    description: "经典武侠喜剧重磅回归，同福客栈迎来新一代侠客，笑闹江湖再起风云。",
    publishDate: "2026-07-31",
    tags: ["喜剧", "武侠", "经典"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v009",
    title: "赛博朋克：边境行者",
    slug: "cyberpunk-bianjing",
    thumbnail: "https://readdy.ai/api/search-image?query=Cyberpunk%20anime%20scene%20with%20robotic%20character%20in%20dystopian%20future%20city%2C%20neon%20orange%20and%20red%20lights%2C%20rainy%20street%2C%20high%20contrast%2C%20anime%20art%20style%2C%20detailed%20mechanical%20design&width=640&height=360&seq=video-thumb-009&orientation=landscape",
    duration: "25:15",
    category: "动漫",
    categorySlug: "dongman",
    views: "680万",
    rating: "9.0",
    description: "在科技高度发达的未来边境城市，一名半机械人战士为自由而战的热血故事。",
    publishDate: "2026-07-29",
    tags: ["科幻", "动作", "国漫"],
    isHot: false,
    isNew: true,
  },
  {
    id: "v010",
    title: "舌尖上的中国：秘境寻味",
    slug: "shejian-zhongguo",
    thumbnail: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20scene%20with%20traditional%20cooking%20in%20rural%20village%2C%20steaming%20hot%20dishes%2C%20warm%20natural%20light%2C%20authentic%20kitchen%20setting%2C%20cinematic%20food%20photography&width=640&height=360&seq=video-thumb-010&orientation=landscape",
    duration: "48:20",
    category: "纪录片",
    categorySlug: "jilupian",
    views: "540万",
    rating: "9.4",
    description: "深入中国最隐秘的村落，探寻那些即将失传的传统美食技艺与背后的动人故事。",
    publishDate: "2026-07-27",
    tags: ["美食", "文化", "传统"],
    isHot: false,
    isNew: true,
  },
  {
    id: "v011",
    title: "英雄联盟S16全球总决赛",
    slug: "lol-s16-finals",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20esports%20arena%20with%20massive%20crowd%2C%20stage%20with%20gaming%20computers%2C%20dramatic%20lighting%20and%20laser%20effects%2C%20excitement%20atmosphere%2C%20professional%20gaming%20tournament%20photography&width=640&height=360&seq=video-thumb-011&orientation=landscape",
    duration: "05:30:00",
    category: "游戏",
    categorySlug: "youxi",
    views: "2100万",
    rating: "9.3",
    description: "全球最强战队汇聚一堂，争夺英雄联盟最高荣耀，精彩操作与战术博弈点燃全场。",
    publishDate: "2026-07-18",
    tags: ["电竞", "LOL", "赛事"],
    isHot: true,
    isNew: false,
  },
  {
    id: "v012",
    title: "歌手2026：巅峰之夜",
    slug: "geshou-2026",
    thumbnail: "https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20singer%20performing%2C%20dramatic%20spotlight%2C%20colorful%20stage%20lighting%2C%20passionate%20performance%2C%20large%20audience%2C%20warm%20golden%20and%20amber%20tones&width=640&height=360&seq=video-thumb-012&orientation=landscape",
    duration: "02:10:45",
    category: "音乐",
    categorySlug: "yinyue",
    views: "1450万",
    rating: "9.0",
    description: "华语乐坛顶级歌手同台竞技，用声音点燃全场，谁将成为年度歌王？",
    publishDate: "2026-07-16",
    tags: ["音乐", "竞技", "直播"],
    isHot: true,
    isNew: false,
  },
];

export const allVideos: VideoItem[] = [...featuredVideos, ...latestVideos];